import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/_auth/dashboard/organizations/$organizationId/(admin)',
)({
    beforeLoad: ({ context, params }) => {
        if (!context.currentUser?.IsAdmin) {
            throw redirect({
                to: '/dashboard/organizations/$organizationId/requests',
                params: { organizationId: params.organizationId },
            });
        }
    },
    component: () => <Outlet />,
});
